export const OPENSTREETMAP_ATTRIBUTION = '&copy; OpenStreetMap contributors';
